'use client';

import { t } from '@lingui/macro';
// Import renderer, note that introducing the CanvasRenderer or SVGRenderer is a required step
import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
// import the core library.
import ReactEChartsCore from 'echarts-for-react/lib/core';
// Import charts, all with Chart suffix
import { GaugeChart } from 'echarts/charts';
// import components, all suffixed with Component
import { GridComponent } from 'echarts/components';
// Import the echarts core module, which provides the necessary interfaces for using echarts.
import * as echarts from 'echarts/core';
import {
  //   CanvasRenderer,
  SVGRenderer,
} from 'echarts/renderers';
import { type FC, useMemo } from 'react';

type Props = {
  score?: number;
  isBlury?: boolean;
};

// Register the required components
echarts.use([GridComponent, GaugeChart, SVGRenderer]);

export const Gauge: FC<Props> = (props: Props) => {
  const { score = 0, isBlury = false } = props;

  const theme = useTheme();

  const option = useMemo(
    () => ({
      series: [
        {
          type: 'gauge',
          startAngle: 180,
          endAngle: 0,
          center: ['50%', '75%'],
          radius: '90%',
          min: 0,
          max: 1,
          splitNumber: 8,
          axisLine: {
            lineStyle: {
              width: 6,
              color: [
                [0.25, '#FF6E76'],
                [0.5, '#FDDD60'],
                [0.75, '#58D9F9'],
                [1, '#7CFFB2'],
              ],
            },
          },
          pointer: {
            icon: 'path://M12.8,0.7l12,40.1H0.7L12.8,0.7z',
            length: '12%',
            width: 20,
            offsetCenter: [0, '-58%'],
            itemStyle: {
              color: 'auto',
            },
          },
          axisTick: {
            length: 8,
            lineStyle: {
              color: 'auto',
              width: 2,
            },
          },
          splitLine: {
            length: 14,
            lineStyle: {
              color: 'auto',
              width: 4,
            },
          },
          axisLabel: {
            color: '#464646',
            fontSize: 14,
            distance: -50,
            rotate: 'tangential',
            formatter: (value: number) => {
              if (value === 0.875) {
                return t`Excellente`;
              }
              if (value === 0.625) {
                return t`Bonne`;
              }
              if (value === 0.375) {
                return t`Passable`;
              }
              if (value === 0.125) {
                return t`Faible`;
              }
              return '';
            },
          },
          title: {
            offsetCenter: [0, '-10%'],
            fontSize: 14,
            fontWeight: 700,
          },
          detail: {
            fontSize: 18,
            offsetCenter: [0, '-35%'],
            valueAnimation: true,
            formatter: (value: number) => `${Math.round(value * 100)}%`,
            color: 'inherit',
          },
          data: [
            {
              value: score,
              name: t`Précision`,
            },
          ],
        },
      ],
    }),
    [score]
  );

  return (
    <Box
      component="div"
      position="relative"
      width={{ none: '300px', sx: '500px' }}
      height="250px"
      sx={{ pointerEvents: 'none' }}
    >
      <ReactEChartsCore
        echarts={echarts}
        option={option}
        notMerge={true}
        lazyUpdate={true}
        theme={'theme_name'}
        style={{ height: '100%', width: '100%', position: 'relative' }}
        opts={{}}
      />
    </Box>
  );
};
